/**
 * Status of a booking line (ProvisionAgentTransaction / ProvisionContractTransaction). ACTIVE is
 * terminal (immutable, no further status change); CANCELLED is a manual discard of a CALCULATED
 * line only. Neither CALCULATED nor CANCELLED contributes to a real (non-simulated) balance.
 *
 * Position-based mirror of the backend enum {@code com.mvs.backend.cp.enums.ProvisionTransactionStatus}. The backend
 * persists the ordinal (`@Enumerated(EnumType.ORDINAL)`), so the declaration order below MUST match
 * the backend exactly and new constants MUST only be appended at the end — never inserted between
 * existing ones, which would silently re-map every stored value (02-datenmodell.md §0.5/§2).
 */
export enum ProvisionTransactionStatus {

    CALCULATED,
    ACTIVE,
    CANCELLED
}
